import React from "react";
import { Link } from "react-router-dom";
import { Gavel } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-zinc-900 bg-black mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 bg-orange-600 flex items-center justify-center border border-orange-500">
              <Gavel className="w-4 h-4 text-white" />
            </div>
            <span className="font-display font-black text-xl tracking-tighter uppercase text-white">
              Storage<span className="text-orange-500">Vault</span>
            </span>
          </Link>
          <p className="mt-4 text-sm text-zinc-500 max-w-md leading-relaxed">
            The industrial-grade storage auction marketplace. Bid on abandoned self-storage units from verified facilities across the country.
          </p>
        </div>
        <div>
          <div className="text-[10px] tracking-[0.25em] uppercase text-zinc-500 mb-4">Marketplace</div>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><Link to="/browse" className="hover:text-orange-500">Browse Auctions</Link></li>
            <li><Link to="/browse?ending_soon=true" className="hover:text-orange-500">Ending Soon</Link></li>
            <li><Link to="/sell" className="hover:text-orange-500">Sell a Unit</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-[10px] tracking-[0.25em] uppercase text-zinc-500 mb-4">Support</div>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><Link to="/how-it-works" className="hover:text-orange-500">How It Works</Link></li>
            <li><span className="text-zinc-600">Buyer Protection</span></li>
            <li><span className="text-zinc-600">Contact</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-900 py-6 text-center text-xs uppercase tracking-[0.25em] text-zinc-600">
        &copy; {new Date().getFullYear()} StorageVault — All bids are binding contracts.
      </div>
    </footer>
  );
}
